import React, { useCallback, useState } from "react";

const NewPagination = React.memo((props) => {
  const { pagination, fetchTableRecords } = props;
    const {data}=props.tableRows
  const totalPages = Math.ceil(pagination.totalRecords / pagination.perPage);

  const [PerPageData] = useState([
    { label: "10", value: 10 },
    { label: "25", value: 25 },
    { label: "50", value: 50 },
    { label: "100", value: 100 },
  ]);

  // Handle page change
  const handlePageChange = useCallback(
    (page) => {
      if (page >= 1 && page <= totalPages && page !== pagination.page) {
        const newPagination = { ...pagination, page };
        fetchTableRecords(newPagination);
      }
    },
    [pagination, fetchTableRecords, totalPages]
  );

  // Per-page change handler
  const perPageDataChangeHandler = useCallback(
    (value) => {
      if (pagination.perPage !== value) {
        const newPagination = { ...pagination, perPage: value, page: 1 };
        fetchTableRecords(newPagination);
      }
    },
    [pagination, fetchTableRecords]
  );

  // Generate visible pages
  const getVisiblePages = () => {
    const maxVisible = 5;
    const current = pagination.page;
    const half = Math.floor(maxVisible / 2);

    let start = Math.max(1, current - half);
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  const visiblePages = getVisiblePages();

  return (
    <>
      {data&&data.length>0&& (
        <div className="d-flex justify-content-between align-items-center mt-1 sh_cardFooter sh_cardbglight sh_pagination">
          {/* Per page dropdown + info */}
          <div className="d-flex align-items-center">
            <span className="text-sm mr-2">Showing</span>
            <div className="dropdown">
              <button
                className="btn bg-white input-group-text mr-2 dropdown-toggle text-sm"
                type="button"
                id="perPageDropdown"
                data-bs-toggle="dropdown"
              >
                {pagination.perPage}
              </button>
              <div
                className="dropdown-menu text-sm"
                aria-labelledby="perPageDropdown"
              >
                {PerPageData.map((itm) => (
                  <button
                    key={itm.value}
                    className={`dropdown-item ${
                      pagination.perPage === itm.value ? "selected" : ""
                    }`}
                    onClick={() => perPageDataChangeHandler(itm.value)}
                  >
                    {itm.label}
                  </button>
                ))}
              </div>
            </div>
            <span className="text-sm">of {pagination.totalRecords} items</span>
          </div>

          <div className="d-flex align-items-center">
            <ul className="sh_paginationbox mb-1 d-flex list-unstyled">
              {/* First Page */}
              {pagination.page !== 1 && (
                <li className="page-item cursor-pointer">
                  <a
                    aria-label="First"
                    title="Go to First Page"
                    className="page-link"
                    onClick={() => handlePageChange(1)}
                  >
                    <span aria-hidden="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="16px"
                        viewBox="0 -960 960 960"
                        width="16px"
                        fill="#023292"
                      >
                        <path d="M440-240 200-480l240-240 56 56-183 184 183 184-56 56Zm264 0L464-480l240-240 56 56-183 184 183 184-56 56Z"></path>
                      </svg>
                    </span>
                  </a>
                </li>
              )}

              {/* Previous Page */}
              {pagination.page !== 1 && (
                <li className="page-item cursor-pointer">
                  <a
                    aria-label="Previous"
                    title="Go to Previous Page"
                    className="page-link"
                    onClick={() => handlePageChange(pagination.page - 1)}
                  >
                    <span aria-hidden="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="16px"
                        viewBox="0 -960 960 960"
                        width="16px"
                        fill="#023292"
                      >
                        <path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"></path>
                      </svg>
                    </span>
                  </a>
                </li>
              )}

              {/* Page Numbers */}
              {visiblePages.map((page) => (
                <li
                  key={page}
                  className={`page-item cursor-pointer ${
                    page === pagination.page ? "active" : ""
                  }`}
                >
                  <a
                    className="page-link action_bg"
                    title={`Go to Page ${page}`}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </a>
                </li>
              ))}

              {/* Next Page */}
              {pagination.page !== totalPages && (
                <li className="page-item cursor-pointer">
                  <a
                    aria-label="Next"
                    title="Go to Next Page"
                    className="page-link"
                    onClick={() => handlePageChange(pagination.page + 1)}
                  >
                    <span aria-hidden="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="16px"
                        viewBox="0 -960 960 960"
                        width="16px"
                        fill="#023292"
                      >
                        <path d="M522-480 333-669l51-51 240 240-240 240-51-51 189-189Z"></path>
                      </svg>
                    </span>
                  </a>
                </li>
              )}

              {/* Last Page */}
              {pagination.page !== totalPages && (
                <li className="page-item cursor-pointer">
                  <a
                    aria-label="Last"
                    title="Go to Last Page"
                    className="page-link"
                    onClick={() => handlePageChange(totalPages)}
                  >
                    <span aria-hidden="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="16px"
                        viewBox="0 -960 960 960"
                        width="16px"
                        fill="#023292"
                      >
                        <path d="M381-480 192-669l51-51 240 240-240 240-51-51 189-189Zm285 0L477-669l51-51 240 240-240 240-51-51 189-189Z"></path>
                      </svg>
                    </span>
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      )}
    </>
  );
});

export default NewPagination;
